import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

interface IGalleryStructure {
    variables: {
        from: string;
    };
}

export const GET_GALLERY_STRUCTURE = gql`
    query GetGalleryStructure($from: String!) {
        galleryStructure(from: $from)
    }
`;

const useGetGalleryStructure = ({ variables }: IGalleryStructure) => {
    return useQuery(GET_GALLERY_STRUCTURE, {
        notifyOnNetworkStatusChange: false,
        fetchPolicy: 'network-only',
        variables,
    });
};

export { useGetGalleryStructure };
